import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { Stack } from '@mui/material';
import useAxiosPrivate from '../../hooks/use-axios-private';
import Empty from '../../components/Empty';
import { useTheme } from '@emotion/react';
import Button from '@mui/material/Button';
import ModalBox from '../../components/ModalBox';
import { Grid, IconButton, TextField as MuiTextField } from '@mui/material'
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { alertMsg } from '../../utils/basicUtils';
import * as Yup from 'yup';
import Popup from '../../components/Popup';
import StrictNumberField from '../../components/StrictNumberField';
import { APP_CURRENCY } from '../../constants';
const headCells = [
    {
        id: 'id',
        numeric: false,
        disablePadding: true,
        label: 'ID',
    },
    {
        id: 'name',
        numeric: true,
        disablePadding: false,
        label: 'Name',
    },
    {
        id: 'price',
        numeric: true,
        disablePadding: false,
        label: `Price (${APP_CURRENCY.currency_symbol})`,
    },

    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
    },

];

const DEFAULT_ROWS_PER_PAGE = 5;

const EnhancedTableHead = (props) => {
    const { order, orderBy } =
        props;

    return (
        <TableHead>
            <TableRow sx={{ height: { xs: 65, xl: 70 } }}>
                <TableCell padding="checkbox">
                    {/* <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    /> */}
                </TableCell>
                {headCells.map((headCell, index) => (
                    <TableCell
                        key={index}
                        align={'center'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ whiteSpace: "nowrap" }}
                    >
                        {
                            // headCell.id !== 'action'
                            //     ?
                            //     <TableSortLabel
                            //         active={orderBy === headCell.id}
                            //         direction={orderBy}
                            //         onClick={() => createSortHandler(headCell.id)}
                            //     >
                            //         {headCell.label}
                            //         {orderBy === headCell.id && (
                            //             <Box component="span" sx={visuallyHidden}>
                            //                 {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            //             </Box>
                            //         )
                            //         }
                            //     </TableSortLabel>
                            //     :
                            headCell.label
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    //  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    // orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { numSelected, onSearchChange } = props
    const theme = useTheme()
    return (
        <>
            <Box sx={{ mt: 3 }}>
                <Toolbar
                    sx={{

                        px: 2,
                        ...(numSelected > 0 && {
                            bgcolor: (theme) =>
                                alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                        }),
                        alignItems: { xs: 'end' }
                    }}
                >
                    {numSelected > 0 ? (
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            color="inherit"
                            variant="subtitle1"
                            component="div"
                        >
                            {numSelected} selected
                        </Typography>
                    ) : (
                        <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'start', md: 'end' }} justifyContent='space-between' sx={{ width: '100%', mt: { xs: 3 } }}>
                            <Typography
                                sx={{ flex: '1 1 100%', color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}
                                id="tableTitle"
                                component="div"

                            >
                                Base Preferences
                            </Typography>

                            <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} alignItems="end" justifyContent="end" sx={{ width: '100%' }}>

                                <Box sx={{ width: { xs: '100%', md: 300 }, maxWidth: '100%', pr: { xs: 0, sm: 2 } }}>
                                    <MuiTextField fullWidth label="Search" variant="standard" size="small" type='search' onChange={onSearchChange} autoComplete='off' />
                                </Box>
                            </Stack>
                        </Stack>
                    )}
                </Toolbar>
            </Box>
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const BasePreferences = () => {
    const theme = useTheme()
    const axios = useAxiosPrivate()
    const [ascorder, setAscorder] = useState("desc")
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
    const [paddingHeight, setPaddingHeight] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [count, setCount] = useState(0);
    const [orderByJobs, setOrderByJobs] = useState([])
    const initialPreferenceValues = {
        name: '',
        price: '',
    }
    const [preferences, setPreferences] = useState(initialPreferenceValues)
    const [preferenceOperation, setPreferenceOperation] = useState('Create')
    const [showAlert, setShowAlert] = useState(false);

    const createPreferenceValidation = Yup.object({
        name: Yup.string()
            .required('preference name is required')
            .max(45, 'preference name cannot exceed 45 characters'),
        price: Yup.number()
            .required('preference Price is required')
            .min(0, 'preference Price should be greater than 0')
            .max(10000, 'Price cannot exceed 10000')
            .test(
                "DecimalPlaces",
                "Decimal places does not exceed 2 characters",
                (number) => Number.isInteger(number * 100)
            ),
    })
    const [modalOpen, setModalOpen] = useState(false)
    const [rows, setRows] = useState([])
    useEffect(() => {
        getPreferenceList()
    }, [rowsPerPage, searchText, page, ascorder, orderByJobs])

    const getPreferenceList = async () => {
        try {
            const resp = await axios.get('settings/available_editing_preferences/', {
                params: {
                    limit: rowsPerPage, search: searchText, page: page + 1
                    , order_by: orderByJobs, order_by_type: ascorder

                }
            })
            setCount(resp.data.data.page_info.count)
            setRows(resp.data.data.available_editing_preferences)
        }
        catch (err) {
            console.error(err)
        }
    }
    const deletePreferences = async (id) => {
        try {
            let resp = await axios.delete('settings/available_editing_preferences/' + id)
            getPreferenceList()
            alertMsg(resp.data.message, 'success')
        } catch (e) {
            console.error(e)
            alertMsg('Failed to delete', 'error')
        }
    }
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            return;
        }
        setSelected([]);
    };
    const orderChange = (newOrderBy) => {
        if (newOrderBy === 'action') {
            return false
        }

        if (ascorder === "desc") {
            setAscorder("asc")
            setOrderByJobs(newOrderBy)
        }
        else {
            setAscorder("desc")
            setOrderByJobs(newOrderBy)
        }
    }


    const handleChangePage = useCallback(
        (event, newPage) => {
            setPage(newPage)
        },
        []
    );

    const handleChangeRowsPerPage = useCallback(
        (event) => {
            const updatedRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(updatedRowsPerPage);
            setPage(0);
            // There is no layout jump to handle on the first page.
            setPaddingHeight(0);
        }, []
    );


    return (
        <>
            <Box sx={{ textAlign: "right" }}>
                <Button
                    variant='outlined'
                    onClick={() => {
                        setPreferences(initialPreferenceValues)
                        setPreferenceOperation('Create');
                        setModalOpen(true)
                    }}
                >Create Base Preferences</Button>
            </Box>

            <Box sx={{ width: '100%' }}>
                <Paper sx={{ width: '100%', mb: 2, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                    <Box>
                        <EnhancedTableToolbar
                            numSelected={selected.length}
                            onSearchChange={
                                (e) => {
                                    setSearchText(e.target.value)
                                }
                            }
                        />
                        {rows.length > 0
                            ?
                            <>
                                <TableContainer>
                                    <Table
                                        sx={{ minWidth: 750, mt: 3 }}
                                        aria-labelledby="tableTitle"
                                        size={'medium'}
                                    >
                                        <EnhancedTableHead
                                            numSelected={selected.length}
                                            //   order={order}
                                            //  orderBy={orderBy}
                                            onSelectAllClick={handleSelectAllClick}

                                            //  onRequestSort={orderChange}
                                            onRequestSort={(newOrderBy) => { orderChange(newOrderBy) }}
                                            rowCount={rows.length}
                                            orderBy={ascorder}
                                        />
                                        <TableBody>
                                            {rows
                                                && rows.map((row, index) =>
                                                    <TableRow sx={{ height: { xs: 65, lg: 70 } }} key={index}>
                                                        <TableCell>
                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.id}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.name}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{APP_CURRENCY.currency_symbol} {row.price}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">
                                                            <Box>

                                                                <IconButton sx={{ ml: 1 }} color="primary" component="span"
                                                                    onClick={() => {
                                                                        setPreferences({ ...row })
                                                                        setModalOpen(true);
                                                                        setPreferenceOperation('Update')
                                                                    }}
                                                                >
                                                                    <EditOutlinedIcon />
                                                                </IconButton>
                                                                <IconButton sx={{ ml: 1 }}
                                                                    color="error"
                                                                    onClick={() => {
                                                                        setShowAlert(true);
                                                                        setPreferences({ ...row })
                                                                    }}
                                                                    component="span">
                                                                    <DeleteOutlineOutlinedIcon />
                                                                </IconButton>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }

                                            {paddingHeight > 0 && (
                                                <TableRow
                                                    style={{
                                                        height: paddingHeight,
                                                    }}
                                                >
                                                    <TableCell colSpan={7} />
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        <Popup show={showAlert} onSecondaryClick={() => setShowAlert(false)} title={"Delete Base Preferences?"} consent={true} variant='error' primaryBtnTxt={"Delete"}
                                            onPrimaryClick={
                                                async (e, loader) => {
                                                    if (e.detail !== 1) {
                                                        return false
                                                    }
                                                    try {
                                                        loader(true)
                                                        await deletePreferences(preferences.id)
                                                        setShowAlert(false)
                                                        loader(false)
                                                    }
                                                    catch (error) {
                                                        console.error(error)
                                                    }
                                                }}
                                        >
                                            <Box sx={{ mt: 2, textAlign: "center" }}>
                                                <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Are you sure you want to delete</Typography>
                                                <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> {preferences.name} </Typography>
                                                <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>base Preferences?</Typography>
                                            </Box>
                                            <Box sx={{ marginTop: "6px", textAlign: "center" }}>
                                                <Typography sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>You can't undo this action.</Typography>
                                            </Box>
                                        </Popup>

                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={count}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </>
                            :
                            <Empty sx={{ border: "none" }} icon={<ManageAccountsOutlinedIcon sx={{ fontSize: 40, color: "grey" }} />} text="No preference available" />
                        }
                        <ModalBox
                            open={modalOpen}
                            onClose={() => { setModalOpen(false) }} >
                            <Box sx={{ mb: 5 }}>
                                <Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 20, xl: 22 } }}>{preferenceOperation} Base Preferences</Typography>
                            </Box>
                            <Formik
                                initialValues={preferences}
                                onSubmit={async (values, { setSubmitting }) => {
                                    let resp = false
                                    if (preferenceOperation === 'Update') {
                                        try {
                                            resp = await axios.put(`settings/available_editing_preferences/${values.id}`, { ...values, is_active: 1 })
                                        } catch (e) {
                                            console.error(e)
                                            alertMsg('Failed to update preference', 'error')
                                            return
                                        }
                                    } else {
                                        try {
                                            resp = await axios.post('settings/available_editing_preferences/', { ...values, is_active: 1 })
                                        } catch (e) {
                                            console.error(e)
                                            alertMsg('Failed to create preference', 'error')
                                            return
                                        }
                                    }
                                    setSubmitting(false);
                                    getPreferenceList()
                                    alertMsg(resp.data.message, 'success')
                                    setModalOpen(false)

                                }}
                                validationSchema={createPreferenceValidation}
                            >
                                {({ submitForm, isSubmitting }) => (
                                    <Form>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Box>
                                                    <Field
                                                        sx={{ mb: { xs: 2, md: 4 } }}
                                                        component={TextField}
                                                        name="name"
                                                        label="Preference Name *"
                                                        fullWidth
                                                        inputProps={{ maxLength: 45 }}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Box>
                                                    <StrictNumberField sx={{ mb: { xs: 2, md: 4 } }} name="price" label="Preference Price *" autoComplete='off' inputProps={{ min: 0, }} component={TextField} type="number" fullWidth />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Box sx={{ mt: 2, textAlign: "right" }}>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                sx={{ mr: 2 }}
                                                onClick={() => setModalOpen(false)}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isSubmitting}
                                                onClick={submitForm}
                                            >
                                                Submit
                                            </Button>
                                        </Box>
                                    </Form>
                                )}
                            </Formik>
                        </ModalBox>
                    </Box>
                </Paper>
            </Box>
        </>
    )
}

export default BasePreferences